/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the FAQ section of organizations.
 */
import { useIntl } from 'react-intl';
import { OrganizationEmptyBoxPlaceholder } from '~/jobiqo/components/Organization/Widgets/OrganizationBoxPlaceholder';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { AddIcon } from '~/vcl/icons/Add';
import { QuestionIcon } from '~/vcl/icons/Question';

export interface OrganizationFAQWidgetEmptyProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string;
}

export const OrganizationFAQWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationFAQWidgetEmptyProps) => {
  const intl = useIntl();

  if (!organization?.canEdit) {
    return null;
  }

  const intlTitle = intl.formatMessage({
    id: 'organization_faq_title',
    defaultMessage: 'Organization frequently asked questions',
  });

  return (
    <Box>
      <OrganizationEmptyBoxPlaceholder
        organization={organization}
        field={boxId}
        multiple={true}
        text={intl.formatMessage({
          id: 'organization_faq_empty_text',
          defaultMessage: `Enter your organizations frequently asked questions here.`,
        })}
        buttonText={intl.formatMessage({
          id: 'organization_faq_empty_enter',
          defaultMessage: `Add question`,
        })}
        icon={<QuestionIcon title={intlTitle} />}
        buttonIcon={<AddIcon title={intlTitle} />}
      />
    </Box>
  );
};
